<div class="container-fluid">
  <div class="card">
    <div class="title">
      <!--title 은 어플에 맞춰 변경해주세요 -->
      <div>이용약관</div>
    </div>
    <div *ngIf="service" class="card-body top">
      <div class="content">{{ service }}</div>
    </div>
  </div>
</div>
